import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const adminFields = (t: (key: string, options?: Record<string, string>) => string) => ({
  name: Yup.string().required(
    t("validation.required", {
      name: t("page.name"),
    })
  ),
  email: Yup.string()
    .email()
    .required(
      t("validation.required", {
        email: t("page.email"),
      })
    ),
  userRole: Yup.string().required(
    t("validation.required", {
      userRole: t("page.user_role"),
    })
  ),
});

export const YupAdmin = () => {
  const { t } = useTranslation();
  return {
    ...adminFields(t),
    password: Yup.string()
      .required(
        t("validation.required", {
          password: t("page.password"),
        })
      )
      .min(8, t("validation.min_length", { min: "8" })),
    confirmPassword: Yup.string()
      .required(
        t("validation.required", {
          confirmPassword: t("page.confirm_password"),
        })
      )
      .min(8, t("validation.min_length", { min: "8" })),
  };
};

export const YupUpdateAdmin = () => {
  const { t } = useTranslation();
  return {
    ...adminFields(t),
    password: Yup.string().min(8, t("validation.min_length", { min: "8" })),
    confirmPassword: Yup.string().min(8, t("validation.min_length", { min: "8" })),
  };
};
